import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { fetchStageGroups } from "Service/ApiService";
import { useLoading } from "context/LoadingContext";
import { useAlert } from "../context/AlertContext";
import { fetchStages } from "Service/ApiService";
import { postStagesData } from "Service/ApiService";
const StagingController = () => {
  const vendor = JSON.parse(localStorage.getItem("vendor"));
  const vendorVertical = vendor.vendorVertical;
  const location = useLocation();
  const { setLoading } = useLoading();
  const [error, setError] = useState({});
  const { showAlert } = useAlert();
  const { PONumber, PODate, totalQuantity } = location.state || {};
  const [stageGroupOptions, setStageGroupOptions] = useState([]);
  const [stages, setStages] = useState([]);
  const [selectedStageGroup, setSelectedStageGroup] = useState();

  useEffect(() => {
    getStageGroupData();
  }, []);

  // Get Stage Group data
  const getStageGroupData = async () => {
    try {
      setLoading(true);
      const response = await fetchStageGroups(vendorVertical,PONumber);

      if (response && response.success === true) {
        const options = response.data.map((row) => ({
          value: row.id,
          label: row.stage_group,
        }));
        setStageGroupOptions(options);
      } else {
        showAlert(response.msg);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert(error);
    }
  };

  const handleStageGroupChange = (selectedOption) => {
    setSelectedStageGroup(selectedOption);
    setStages([]);
    getStagesData(selectedOption.value);
  };

  const getStagesData = async (value) => {
    try {
      setLoading(true);
      const response = await fetchStages(vendor.vendorCode, PONumber, value);

      if (response && response.success === true) {
        const formatted = response.data.map((item) => ({
          ...item,
          isFromAPI: item.fresh_qty !== null && item.fresh_qty !== "",
        }));
        setStages(formatted);
      } else {
        showAlert(response.msg);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert(error);
    }
  };

  const handleQuantityChange = (index, value) => {
    const sanitizedValue = value.replace(/\D/g, "");
    setStages((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        fresh_qty: sanitizedValue, // string or number
      };
      return updated;
    });
  };

  const handleRemarkChange = (index, value) => {
    setStages((prev) => {
      const updated = [...prev]; // copy array
      updated[index] = { ...updated[index], remark: value };
      return updated;
    });
  };

  const handleSubmit = async () => {
    try {
      const stageEntries = Object.entries(stages);
      let anyFilled = false;
      let totalUsedQuantity = 0;

      // Prepare stages to send
      const stagesToSend = {};

      for (const [stageName, data] of stageEntries) {
        const currentQuantity = Number(data.fresh_qty) || 0;

        if (currentQuantity > 0) {
          anyFilled = true;
          totalUsedQuantity += currentQuantity;
          stagesToSend[stageName] = {
            ...data,
            fresh_qty: currentQuantity, // number
          };
        } else {
          // 0 quantity → send as empty string
          stagesToSend[stageName] = {
            ...data,
            fresh_qty: "", // empty
          };
        }
      }

      // Check if at least one stage has quantity
      if (!anyFilled) {
        showAlert("Please enter quantity for at least one stage.");
        return;
      }

      // Check if total quantity exceeds allowed totalQuantity
      if (totalUsedQuantity > totalQuantity) {
        showAlert(`Total quantity across all stages exceeds ${totalQuantity}.`);
        return;
      }

      setLoading(true);
      const response = await postStagesData(
        vendor.vendorCode,
        vendor.vendorName,
        PONumber,
        PODate,
        totalQuantity,
        stagesToSend
      );

      if (response && response.success === true) {
        showAlert(response.message, {
          title: "Success",
          icon: "success",
          timer: 1500,
        });
        setStages([]);
        getStagesData(selectedStageGroup.value);
      } else {
        showAlert(response.message);
      }
    } catch (error) {
      showAlert(error);
    } finally {
      setLoading(false);
    }

    // If no errors, proceed
    console.log("All stages valid:", stages);
    // Submit the stages data to API
  };

  return {
    PONumber,
    PODate,
    totalQuantity,
    error,
    stageGroupOptions,
    selectedStageGroup,
    stages,
    handleStageGroupChange,
    handleQuantityChange,
    handleRemarkChange,
    handleSubmit,
    vendorVertical,
  };
};

export default StagingController;
